import { DialogStateManager } from '@/features/dialog/dialog-provider';
import type { ComponentPropsWithoutRef } from 'react';
import React, { forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { DraftOrderCreateDialog } from './draft-order-create-dialog';

interface CreateNewDraftLinkProps extends Omit<ComponentPropsWithoutRef<'a'>, 'to'> {
    customerId?: string;
}

export const CreateNewDraftLink = forwardRef<React.ElementRef<'a'>, CreateNewDraftLinkProps>(
    ({ customerId, ...props }, ref) => {
        const navigate = useNavigate();

        const handleCreateNewDraft = (e: { preventDefault: () => void }) => {
            e.preventDefault();

            DialogStateManager.show(DraftOrderCreateDialog, {
                customerId: customerId,
                onSuccess: (data) => {
                    navigate(`/drafts/${data.draft_order.draft_order_id}/line-items`);
                },
            });

            return null;
        };

        return (
            <a
                {...props}
                className="text-blue-700 hover:underline"
                onClick={handleCreateNewDraft}
                ref={ref}
            />
        );
    },
);

CreateNewDraftLink.displayName = 'CreateNewDraftLinkTag';
